<template>
  <div>
    <div class="q-toolbar">
      <div class="q-toolbar-buttons">
        <q-label
          v-model="trusted.caption"
          width="200"
        />
        <q-input
          v-model="word"
          :placeholder="this.$qt('listStructure.searchPlaceHolder')"
          :style="searchStyle"
        >
          <q-button
            slot="append"
            type="info"
            icon="q-icon-search"
          />
        </q-input>

        <q-button
          class="q-toolbar-btn"
          @click="updatePermission"
        >
          <font-awesome-icon :icon="['fas', 'save']" />
        </q-button>
      </div>
    </div>

    <q-table
      stripe
      border
      :data="filteredData"
      width="100%"
      sum-text="----"
      :empty-text="this.$qt('listStructure.emptyList')"
    >
      <q-table-column
        prop="caption"
        :label="this.$qt('permission.editor.captionColumnText')"
      />

      <q-table-column
        width="100"
        :label="this.$qt('permission.editor.isGrant')"
      >
        <template slot-scope="scope">
          <div class="q-toolbar-buttons">
            <q-checkbox
              v-model="scope.row.grant"
            />
          </div>
        </template>
      </q-table-column>

      <q-table-column
        v-for="permission in permissions"
        :key="permission.key"
        :label="permission.caption"
        width="70"
      >
        <template slot-scope="scope">
          <template>
            <q-checkbox
              v-model="scope.row[permission.key]"
            />
          </template>
        </template>
      </q-table-column>
    </q-table>
  </div>
</template>

<script>

  import listMixin from '../../../../../q-components/mixins/listMixin';

  export default {
    name: "QTrustedPermissions",

    mixins: [listMixin],
    props: {
      trusted: {
        required: true
      },
      permissions: {
        required: true
      }
    },
    data() {
      return {
        fullAccess: false,
        isIndeterminate: true
      }
    },
    computed: {
      searchStyle() {
        const ret = {};
        if (this.$isRtl)
          ret.marginRight = '5px';
        else
          ret.marginLeft = '5px';
        return ret;
      },
      firstButtonStyle() {
        const ret = {};
        if (this.$isRtl)
          ret.marginRight = '0';
        else
          ret.marginLeft = '0';
        return ret;
      },
    },
    methods: {
      changeFullAccess(index, row) {
        if (row.fullAccess) {
          for (let item in this.permissions) {
            row[this.permissions[item].key] = true;
          }
        } else {
          for (let item in this.permissions) {
            row[this.permissions[item].key] = false;
          }

        }
      },
      updatePermission() {
        this.$emit('update');
      }
    },
  }
</script>

<style scoped>
  .q-toolbar {
    margin-bottom: 15px;
  }

  .q-toolbar-buttons {
    display: -webkit-box;
    display: -ms-flexbox;

    display: flex;
    line-height: 15px;
  }

  .q-toolbar-btn {
    margin-left: 3px;
    margin-right: 3px;
  }
</style>